var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftBtn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666553 5.53332L4.46655 9.26666C4.73322 9.53332 5.13322 9.53332 5.39989 9.26666C5.66655 8.99999 5.66655 8.59999 5.39989 8.33332L2.13322 4.99999L5.39989 1.66666C5.66655 1.39999 5.66655 0.999992 5.39989 0.733325C5.26655 0.599992 5.13322 0.533325 4.93322 0.533325C4.73322 0.533325 4.59989 0.599992 4.46655 0.733325L0.666553 4.46666C0.399886 4.79999 0.399886 5.19999 0.666553 5.53332C0.666553 5.46666 0.666553 5.46666 0.666553 5.53332Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBtn);
export default __webpack_public_path__ + "static/media/arrow-left-btn.203a41d55aebbd88911fa1643f293619.svg";
export { ForwardRef as ReactComponent };